import { render, staticRenderFns } from "./viewAPI2.vue?vue&type=template&id=3af7f13d&scoped=true&"
import script from "./viewAPI2.vue?vue&type=script&lang=js&"
export * from "./viewAPI2.vue?vue&type=script&lang=js&"
import style0 from "./viewAPI2.vue?vue&type=style&index=0&id=3af7f13d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af7f13d",
  null
  
)

export default component.exports